<template>
    <ModalComponent
        :name="'cambiar-asiento-' + abonado.id"
        :title="'Cambiar asiento ' + abonado.name + ' ' + abonado.surnames"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12">
                <span class="h3"><b>Información del abonado</b></span>
            </div>
            <div class="col-12 mt-2">
                <ul>
                    <li>
                        <b>Nº de abonado:</b> {{ abonado.n_abonado }}
                    </li>
                    <li>
                        <b>Nombre:</b> {{ abonado.name }}
                    </li>
                    <li>
                        <b>Apellidos:</b> {{ abonado.surnames }}
                    </li>
                    <li>
                        <b>Zona:</b> {{ abonado.tiene_asiento ? abonado.asiento.region : abonado.plaza?.region_name }}
                    </li>
                    <template v-if="abonado.tiene_asiento">
                        <li>
                            <b>Fila:</b> {{ abonado.asiento.row }}
                        </li>
                        <li>
                            <b>Butaca:</b> {{ abonado.asiento.seat }}
                        </li>
                    </template>
                    <li v-else-if="abonado.plaza">
                        <b>Plaza Nº:</b> {{ abonado.plaza.numero }}
                    </li>
                </ul>
            </div>
            <div class="col-12">
                <span class="h3"><b>Selecciona una zona</b></span> <span class="h5"> (Al hacer click en {{ !abonado.plaza ? 'el asiento este' : 'la plaza esta' }} se cambiará)</span>
                <button class="btn btn-secondary btn-sm ml-3" :disabled="loading || loading_zonas" @click="new_zona = null" v-if="new_zona">Cambiar zona</button>
            </div>
            <template v-if="!new_zona">
                <div class="col-12 mt-3" v-if="!loading_zonas">
                    <div class="row form-group" v-if="zonas?.length">
                        <div class="col-4 pr-0">
                            <TablaSectoresComponent :zonas="zonas" @goTo="(paso, zona) => { new_zona = { ...zona } }"/>
                        </div>
                        <div class="col-8 pl-0">
                            <SvgComponent :zonas="zonas" :place="place" @clickZona="(zona) => { new_zona = { ...zona } }" />
                        </div>
                    </div>
                </div>
                <template v-else>
                    <LoaderComponent />
                </template>
            </template>
            <div class="col-12">
                <CambiarAsientoNormal v-if="tipo_svg == 1" :zona="new_zona" :loading.sync="loading" @cambiarAsiento="toggleSeleccion" />
                <CambiarPlaza v-else :tipo_svg="tipo_svg" :zona="new_zona" :plaza_abonado="abonado.plaza" @cambiarPlaza="toggleSeleccion" />
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import TablaSectoresComponent from '@/components/backend/stepper/components/TablaSectoresComponent';
    import SvgComponent from '@/components/svg/SvgComponent';
    import CambiarAsientoNormal from "@/components/backend/abonados/cambiar-asiento/CambiarAsientoNormal";
    import CambiarPlaza from "@/components/backend/abonados/cambiar-asiento/CambiarPlaza";

    export default {
        props: ['abonado'],
        data() {
            return {
                new_zona: null,
                loading: false,
                loading_zonas: false,
                zonas: null,
            }
        },
        methods: {
            close() {
                this.new_zona = null;
                this.$emit('close', this.abonado.id);
            },
            getZonas() {
                this.loading_zonas = true;

                this.$store.dispatch(this.config.getVuexAlias('zonas.index')).then(res => {
                    this.zonas = res.data;

                    this.getZonasAnexas();
                });
            },
            getZonasAnexas() {
                const params = {
                    filters: {},
                    lista_id: this.lista.id,
                    recinto_id: this.lista.place.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.taquilla.regiones-anexas'), params).then(res => {
                    this.zonas = this.zonas.concat(res.data.data);
                }).finally(() => {
                    this.loading_zonas = false;
                })
            },
            toggleSeleccion(fila, asiento, ocupado, plaza_id = null) {
                this.loading = true;

                const params = {
                    abonado_id: this.abonado.id
                }

                if (plaza_id) {
                    params.plaza_id = plaza_id
                } else {
                    params.asiento = {
                        row: fila,
                        seat: asiento,
                        region_id: this.new_zona.id
                    }
                }

                if (ocupado == 0) {
                    this.$store.dispatch(this.config.getVuexAlias('back.abonados.asiento'), params).then(res => {
                        this.$emit('asientoEditado');
                        this.$toast.success(!this.new_zona.tiene_plazas ? "¡Asiento editado!" : "¡Plaza editada!");
                    }).catch(error => {
                        this.$toast.error(!this.new_zona.tiene_plazas ? 'El asiento esta ocupado' : 'La plaza está ocupada');
                    }).finally(() => {
                        this.loading = false;
                    });
                } else {
                    this.$toast.error(!this.new_zona.tiene_plazas ? 'El asiento esta ocupado' : 'La plaza está ocupada');
                    this.loading = false;
                }
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaAbonados;
            },
            place() {
                return this.lista.place;
            },
            tipo_svg() {
                if (this.new_zona) {
                    return parseInt(this.new_zona.tipo_svg);
                }

                return this.$store.getters.getRecinto.tipo_svg;
            }
        },
        created() {
            this.getZonas();
        },
        components: {
            ModalComponent, CambiarAsientoNormal, CambiarPlaza, TablaSectoresComponent, SvgComponent
        }
    }
</script>
